module.exports = __webpack_public_path__ + "img/1596.6db2d012.png";